<template>
    <div>
        <vue2-dropzone :id="`file-uploader-${recordId}-${recordType}`" :options="dropzoneOptions" @vdropzone-success="emitFileUpload"></vue2-dropzone>
    </div>
</template>

<script>
    export default {
        props: {
            recordId: {
                type: Number,
                required: true
            },
            recordType: {
                type: String,
                required: true,
            },
            postUrl: {
                type: String,
                default: 'files/upload',
            },
            acceptedFileTypes: {
                // THIS IS NOT ENFORCED ON THE SERVER, YOU MUST VALIDATE THIS YOURSELF
                type: String,
                default: 'JPG, JPEG, PNG, PDF, DOCX, CSV, XLS, XLSX, MP4, AVI, MOV, MPG, MPEG, FLV, WEBM, MKV, OGV'
            },
            acceptedFileExtensions: {
                // THIS IS NOT ENFORCED ON THE SERVER, YOU MUST VALIDATE THIS YOURSELF
                // MUST INCLUDE PERIODS
                type: String,
                default: '.jpg, .jpeg, .png, .pdf, .docx, .csv, .xls, .xlsx, .mp4, .avi, .mov, .mpg, .mpeg, .flv, .webm, .mkv, .ogv'
            }
        },

        data: function() {
            return {
                dropzoneOptions: {
                    url: this.$http.base() + '/' + this.postUrl,
                    dictDefaultMessage: `Click to Upload Files. Acceptable files types are:<br> ${this.acceptedFileTypes}. Max File Size: 50MB.`,
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('amos_365_token'),
                    },
                    params: {
                        record_type: this.recordType,
                        record_id: this.recordId
                    },
                    acceptedFiles: this.acceptedFileExtensions,
                }
            }
        },

        methods: {

            //Get the thumbnail preview
            getPreview(file){

            },

            loadThumbnail(file){
                //Send it
                this.$http.get('files/view/'+file.file_id, {display_type: 'fluid'})
                    .then(response => {
                        //console.log(this.$refs);
                        //Sent the ref
                        this.$refs['file-' + file.file_id][0].src = response.data;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });
            },

            emitFileUpload(file, response){
                //Do it
                this.$emit('fileUploaded', {dzFile: file, serverResponse: response});
            }
        },

        mounted() {

        }
    }
</script>

<style>
    .dropzone {
        border: 1px dashed #b1b1b1;
        border-radius: 0;
        padding: 7px;
    }

    .dropzone .dz-message {
        font-size: 16px;
        margin: 50px 0;
    }
</style>